(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flexi-categories-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-categories-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 3.2,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                    prevArrow: el.querySelector('.blaze-prev'), 
                    nextArrow: el.querySelector('.blaze-next'), 
                },
                '(max-width: 1024px)': {
                    slidesToShow: 2.7,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });

        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-collection"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-cards-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 4.2,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                    prevArrow: el.querySelector('.blaze-prev'), 
                    nextArrow: el.querySelector('.blaze-next'), 
                },
                '(max-width: 1024px)': {
                    slidesToShow: 3,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });

        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-columns"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-columns-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });
        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-featured-images"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function() {
        let images = document.querySelectorAll('.flexi-slideshow-image, .flexi-slideshow-placeholder');
        let currentIndex = 0;
    
        images[0].style.display = 'block';
    
        function showNextImage() {
        images[currentIndex].style.display = 'none'; 
        images[currentIndex].classList.remove('flexi-featured-image-fade');
    
        currentIndex = (currentIndex + 1) % images.length;
        images[currentIndex].style.display = 'block';
        images[currentIndex].classList.add('flexi-featured-image-fade'); 
    
        let loadingBar = document.querySelector('.flexi-loading-bar');
        loadingBar.style.animation = 'none';
        loadingBar.offsetHeight;
        loadingBar.style.animation = '';
        }
    
        setInterval(showNextImage, 3000);
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-full-width-image"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders(target = document) {
        target.querySelectorAll('.flexi-full-width-image-slider').forEach((el) => {

            const parent = el.parentNode;
            const clone = el.cloneNode(true);
            parent.replaceChild(clone, el);

            new BlazeSlider(clone, {
                all: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplayInterval: 2000,
                    transitionDuration: 300,
                    loop: true,
                    enableAutoplay: true,
                    draggable: true,
                },
            });
        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
        initBlazeSliders(event.target);
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-how-it-works"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initTestBlazeSliders() {
        document.querySelectorAll('.flexi-how-it-works-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });
        });
    }

    initTestBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initTestBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-image-comparison"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", function () {
      const sliders = document.querySelectorAll(".flexi-image-comparison-slider");
      
      sliders.forEach(function(slider) {
        const sliderImgWrapper = slider.querySelector(".flexi-img-wrapper");
        const sliderHandle = slider.querySelector(".handle");
        
        function sliderMouseMove(event) {
          if (slider.isSliderLocked) return;
    
          const sliderRect = slider.getBoundingClientRect();
          let mouseX = (event.clientX || event.touches[0].clientX) - sliderRect.left;
          if (mouseX < 0) mouseX = 0;
          else if (mouseX > sliderRect.width) mouseX = sliderRect.width;
          
          sliderImgWrapper.style.width = `${((1 - mouseX / sliderRect.width) * 100).toFixed(4)}%`;
          sliderHandle.style.left = `calc(${((mouseX / sliderRect.width) * 100).toFixed(4)}% - ${sliderHandle.offsetWidth / 2}px)`;
        }
        
        slider.addEventListener("mousemove", sliderMouseMove);
        slider.addEventListener("touchmove", sliderMouseMove);
        
        slider.addEventListener("mousedown", () => { slider.isSliderLocked = false; });
        slider.addEventListener("touchstart", () => { slider.isSliderLocked = false; });
        slider.addEventListener("mouseup", () => { slider.isSliderLocked = true; });
        slider.addEventListener("touchend", () => { slider.isSliderLocked = true; });
        slider.addEventListener("mouseleave", () => { slider.isSliderLocked = true; });
        
        slider.isSliderLocked = false;
      });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-instagram"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-columns-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });
        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-product-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-cards-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 4.2,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                    prevArrow: el.querySelector('.blaze-prev'), 
                    nextArrow: el.querySelector('.blaze-next'), 
                },
                '(max-width: 1024px)': {
                    slidesToShow: 3,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });

        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-product-columns"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-columns-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 6,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });
        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput = this.form.querySelector('[name="id"]');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.spinner = this.querySelector('.flexi-loading-spinner');
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.quantityInput = this.querySelector('[name="quantity"]');

        this.variantIdInput.disabled = false;

        // Add event listener for the quantity input
        if (this.quantityInput) {
          this.quantityInput.addEventListener('input', this.onQuantityChange.bind(this));
        }

        // Add event listener for the form submission
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      onQuantityChange(evt) {
        // Prevent form submission on quantity change
        evt.preventDefault();
        const quantity = parseInt(evt.target.value, 10) || 1;
        if (quantity < 1) {
          this.quantityInput.value = 1;
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.toggleLoadingState(true);

        const formData = new FormData(this.form);
        const config = {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        };

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        fetch('/cart/add.js', config)
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              this.handleErrorMessage(data.description || 'An error occurred.');
              this.toggleSubmitButton(true, 'Sold Out');
              return;
            }

            if (this.cart) {
              this.triggerCartNotification(data);
            } else {
              window.location = '/cart';
            }
          })
          .catch((err) => console.error(err))
          .finally(() => this.toggleLoadingState(false));
      }

      triggerCartNotification(cartData) {
        if (this.cart.tagName.toLowerCase() === 'cart-notification') {
          this.cart.renderContents(cartData);
        } else if (this.cart.tagName.toLowerCase() === 'cart-drawer') {
          this.cart.renderContents(cartData);
          this.cart.classList.add('is-open');
        }
      }

      toggleLoadingState(isLoading) {
        if (isLoading) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          if (this.spinner) {
            this.spinner.classList.add('visible');
          }
          const atcContent = this.submitButton.querySelector('.flexi-atc-content');
          if (atcContent) {
            atcContent.classList.add('hidden');
          }
        } else {
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButton.classList.remove('loading');
          if (this.spinner) {
            this.spinner.classList.remove('visible');
          }
          const atcContent = this.submitButton.querySelector('.flexi-atc-content');
          if (atcContent) {
            atcContent.classList.remove('hidden');
          }
        }
      }

      handleErrorMessage(errorMessage = '') {
        const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
        const errorElement = this.querySelector('.product-form__error-message');
        if (!errorWrapper || !errorElement) return;

        if (errorMessage) {
          errorWrapper.hidden = false;
          errorElement.textContent = errorMessage;
        } else {
          errorWrapper.hidden = true;
        }
      }

      toggleSubmitButton(disable, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = 'Add to Cart';
        }
      }
    }
  );
}

document.addEventListener('DOMContentLoaded', function () {
  const initProductBlazeSliders = () => {
    document.querySelectorAll('.flexi-product-slider').forEach((slider) => {
      // Initialize Blaze Slider
      const sliderInstance = new BlazeSlider(slider, {
        all: {
          slidesToShow: 1,
          slidesToScroll: 1,
          loop: false,
          draggable: true,
          prevArrow: slider.querySelector('.blaze-prev'),
          nextArrow: slider.querySelector('.blaze-next'),
        },
        '(max-width: 1024px)': {
          slidesToShow: 1.2,
        },
      });

      // Get track and slides
      const track = slider.querySelector('.blaze-track');
      const slides = Array.from(track.querySelectorAll('.blaze-product-slide'));

      // Track the current slide index
      let currentSlideIndex = 0;

      // Update the currentSlideIndex whenever the slide changes
      const unsubscribe = sliderInstance.onSlide((pageIndex) => {
        currentSlideIndex = pageIndex;
      });

      // Listen for variant changes
      document.addEventListener('on:variant:change', (event) => {
        const { variant } = event.detail;

        if (variant) {
          // Find the slide corresponding to the variant ID
          const targetSlide = slides.find((slide) =>
            slide.getAttribute('data-variant-id') === variant.id.toString()
          );

          if (targetSlide) {
            const targetSlideIndex = slides.indexOf(targetSlide);

            if (targetSlideIndex !== -1) {
              // Calculate the number of slides to move
              const slideDifference = targetSlideIndex - currentSlideIndex;

              if (slideDifference > 0) {
                sliderInstance.next(slideDifference); // Move forward
              } else if (slideDifference < 0) {
                sliderInstance.prev(Math.abs(slideDifference)); // Move backward
              }
            }
          } else {
            console.warn(`No slide found for variant ID: ${variant.id}.`);
          }
        }
      });

      // Clean up listeners when section is unloaded
      document.addEventListener('shopify:section:unload', () => {
        unsubscribe();
      });
    });
  };

  initProductBlazeSliders();

  document.addEventListener('shopify:section:load', initProductBlazeSliders);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-rotating-reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-rotating-reviews-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    loop: true,
                    enableAutoplay: true,
                    autoplayInterval: 2000,
                    transitionDuration: 300,
                    draggable: true,
                    prevArrow: el.querySelector('.blaze-prev'), 
                    nextArrow: el.querySelector('.blaze-next'), 
                },
                '(max-width: 1024px)': {
                    slidesToShow: 3,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });

        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-scrollable-cards"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-cards-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 4.2,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                    prevArrow: el.querySelector('.blaze-prev'), 
                    nextArrow: el.querySelector('.blaze-next'), 
                },
                '(max-width: 1024px)': {
                    slidesToShow: 3,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });

        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-full-width-slider').forEach((el) => {
            new BlazeSlider(el, {
              all: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    loop: true,
                    draggable: true,
                },
            });
        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function (event) {
        initBlazeSliders();
    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-testimonials"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initBlazeSliders() {
        document.querySelectorAll('.flexi-testimonials-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplayInterval: 2000,
                    transitionDuration: 300,
                    loop: true,
                    enableAutoplay: true,
                    draggable: true,
                },
            });

        });
    }

    initBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["flexi-why-us"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
    function initTestBlazeSliders() {
        document.querySelectorAll('.flexi-why-us-slider').forEach((el) => {

            new BlazeSlider(el, {
                all: {
                    slidesToShow: 10,
                    slidesToScroll: 1,
                    loop: false,
                    draggable: true,
                },
                '(max-width: 900px)': {
                    slidesToShow: 2.2,
                },
                '(max-width: 500px)': {
                    slidesToShow: 1.2,
                },
            });
        });
    }

    initTestBlazeSliders();

    document.addEventListener('shopify:section:load', function(event) {
        initTestBlazeSliders();
    });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
